export const CUSTOM_REPORT_PREVIEW_VERSION = 1;
export const COMPARISON_REPORT_PREVIEW_VERSION = 14;
